<template>
  <div class="rootDiv">
    <CellSwipe class="cellswipe">
      <div class="mint-cell-title"
           style="position: absolute; width: 100%; height: 100%; left: 0; top: 0;">
        <label class="mint-checklist-label"
               style="text-align: left;margin:0.4rem;">
          <div style="float: left;">
            <avatar slot="icon" class="avatar" username="Birth Circle"
                    :src="CircleModel.qZTB"
                    :size="48">
            </avatar>
          </div>
          <div style="float: left;margin-top: 0.5rem;margin-left: 0.6rem">
            <div>
              <span style="color: green;font-size: 1.2rem">{{ CircleModel.qZMC }}</span>
            </div>
            <div style="margin-top: 0.2rem">
              <span style="font-size: 0.8rem">圈子号：</span>
              <span style="font-size: 0.8rem;color: blue">{{ CircleModel.qZHM }}</span>
            </div>
          </div>
        </label>
      </div>
    </CellSwipe>
    <Cell title="创建时间" :value="CircleModel.cJSJ | formatDate" style="text-align: left"></Cell>
    <Cell title="创建人" :value="CircleModel.creator " style="text-align: left"></Cell>
    <Cell title="管理员" :value="CircleModel.administrator " style="text-align: left"
          :is-link="CircleModel.qZGLY===yhnm"></Cell>
    <Cell title="生日数量" :value="CircleModel.birthCount " style="text-align: left" is-link
          v-on:click.native="Details(CircleModel.qZNM,CircleModel.qZGLY===yhnm)"></Cell>
    <Cell title="用户数量" :value="CircleModel.userCount " style="text-align: left" is-link
          v-on:click.native="UserDetails(CircleModel.qZNM)"></Cell>
    <Field label="圈子介绍" placeholder="圈子介绍" type="textarea" rows="4" v-model="CircleModel.qZJJ"
           style="margin-left: -1.2rem" :readonly="CircleModel.qZGLY!==yhnm"></Field>
    <div class="bottomContent">
      <Button size="large" type="danger" class="logoutButton"
              @click="buttonClick(CircleModel.qZGLY===yhnm,yhnm,CircleModel.qZNM)"><span
          v-if="CircleModel.qZGLY!==yhnm">退 出</span><span v-if="CircleModel.qZGLY===yhnm">解 散</span></Button>
    </div>
  </div>
</template>

<script>
import {Cell, CellSwipe, Field} from "mint-ui";
import Avatar from 'vue-avatar'
import CirclePage from "@/components/menu/Circle/CirclePage";
import {formatdate} from "@/js/DateUtils";

export default {
  name: "CircleDetails",
  data() {
    return {
      yhnm: localStorage.getItem('yhnm'),
      CircleModel: CirclePage.data().circleModel,
      token: localStorage.getItem('token'),
      QuitOrDissolveUrl: '/api/circle/quitOrDissolve',
    }
  },
  filters: {
    formatDate(time) {
      const date = new Date(time);
      return formatdate(date, 'yyyy年MM月dd日');  // 此处可根据自己的需要自定义想要的日期格式
    },
  },
  components: {Cell, CellSwipe, Field, Avatar},
  mounted() {
    if (this.$route.params.circle === undefined) {
      this.$router.go(-1)
    } else {
      this.CircleModel = JSON.parse(this.$route.params.circle)
    }
  },
  methods: {
    Details(qznm, bo) {
      this.$router.push({name: 'm_circle_birthday', query: {qznm: qznm, isManagerPage: bo ? "1" : "0"}})
    },
    UserDetails(qznm) {
      this.$router.push({name: 'm_circle_user', query: {qznm: qznm}})
    },
    buttonClick(isManager, yhnm, qznm) {
      let that = this
      let message = '解散圈子'
      if (!isManager) {
        message = '退出圈子'
      }
      that.$messagebox.confirm("确认" + message + "?").then(action => {
        if (action === 'confirm') {
          that.$ajax({
            method: 'get',
            url: that.QuitOrDissolveUrl,
            params: {yhnm: yhnm, qznm: qznm, isManager: isManager},
            headers: {token: that.token}
          }).then((response) => {
            if (response.data.result) {
              this.$router.push('/m_circle_manager');
              console.log(response)
            } else {
              that.$messagebox.alert(response.data.message)
            }
          }).catch(response => {
            that.$messagebox.alert(response.request.status === 404 ? "服务器连接失败" : "未知错误，请联系服务商", '服务器异常')
          })
        }
      })
    },
  },
}
</script>

<style lang="less" scoped>
.rootDiv {
  margin-top: -0.5rem;
}

.cellswipe {

  background-color: #dde5ee;
  margin-left: -0.5rem;
  margin-right: -0.5rem;

  /deep/ .mint-cell-wrapper {
    min-height: 60px;
  }
}

.bottomContent {
  margin-top: 2rem;

  Button {
    width: 100%;
    background-color: #d20e2b;
    font-size: 1.2rem;
    height: 40px;
  }
}
</style>
